import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import Body from '../body/Theory';
import Hero from '../hero/hero';
import BreadCrumb from '../utility/breadCrumb';

function Index() {
  return (
    <>
      <BreadCrumb 
        linkto="theory" 
        linkname="Music Theory" 
        linklevel="1" 
        linktoone="" 
        linknameone=""
        linktotwo="" 
        linknametwo="" 
      >
      </BreadCrumb>
      <Hero 
        paddingTop = "0px"
        id="2" 
        contentId="2"
        height="300" 
        gradient="true" 
        gradientDirection="to right" 
        gradientRgba="rgba(255,255,255,1) 70%, transparent" 
        backgroundSize="auto 100%" 
        backgroundRepeat="no-repeat" 
        backgroundColor="#fff" 
        backgroundPosition="right"
        borderwidth="1"
        bordercolor="#9E2218"
        bordertype="solid"
        maxWidth="1400px"
        margin="auto"  >
      </Hero>
      <Body id="3"></Body>
    </>
  );
}

export default Index;
